// extracted by mini-css-extract-plugin
module.exports = {"warningBox":"SharingWarning_warningBox__G7hqT","warningPhone":"SharingWarning_warningPhone___UQKK"};